import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const headingFontFamily = '"Albra Sans", -apple-system, sans-serif';

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#000000",
    },
  },
  typography: {
    fontFamily: '"Apercu Pro", -apple-system, sans-serif',
    ...Object.fromEntries(["h1", "h2", "h3", "h4", "h5", "h6"].map((h) => [h, { fontFamily: headingFontFamily }])),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          minWidth: "auto",
        },
        containedPrimary: {
          backgroundColor: "#000000",
          color: "#ffffff",
        },
        outlinedPrimary: {
          borderColor: grey[500],
        },
        outlined: {
          borderColor: grey[500],
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          maxHeight: "40vh",
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          maxHeight: "40vh",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: grey[500],
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreIcon,
      },
      styleOverrides: {
        icon: {
          fontSize: "1.2rem",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          "& .MuiInputBase-root": {
            fontSize: "14px",
            borderRadius: "16px",
          },
          "& .MuiFormControl-root": {
            "& .MuiOutlinedInput-input": {
              paddingTop: "5px",
              paddingBottom: "5px",
            },
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-cell": {
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            borderRight: "1px solid",
            borderRightColor: grey[300],
            borderBottom: "1px solid",
            borderBottomColor: grey[300],
            "& .MuiInputBase-root": {
              fontSize: "14px",
              borderRadius: "16px",
            },
            "& .MuiFormControl-root": {
              "& .MuiOutlinedInput-input": {
                paddingTop: "5px",
                paddingBottom: "5px",
              },
            },
          },
          // Set background colors
          "--DataGrid-pinnedBackground": "#ffffff",
          "--DataGrid-containerBackground": "#ffffff",
          // Style cells with right border
          "& .MuiDataGrid-cell--withRightBorder": {
            boxShadow: "inset -2px 0 0 0 rgba(0,0,0,0.2)",
          },
          "& .MuiDataGrid-columnHeader--withRightBorder": {
            boxShadow: "inset -2px 0 0 0 rgba(0,0,0,0.2)",
          },
          "& .MuiDataGrid-columnHeader": {
            borderRight: "1px solid",
            borderRightColor: grey[300],
            borderBottom: "1px solid",
            borderBottomColor: grey[300],
          },
          "& .MuiDataGrid-columnSeparator--resizable:not(:hover) rect": {
            color: grey[500],
          },
        },
      },
    },
  },
});

export default theme;
